import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { fontSize14 } from './typography.style';
import InlineSvg from '../inline-svg/inline-svg';
import { spacing20 } from './spacing.style';
import { grey7 } from './colours.style';

//We have 'content-thumbnails', 'result (already SC)' and 'simple-thumbnails'
//They have a few of things in common, so I'm dumping those
//common things here ¯\_(ツ)_/¯

export const OverlayPillThumbnailIcon = styled(InlineSvg)`
  margin-right: ${rem(5)};
`;

const buttonHeight = 36;
const wrapperPadding = 9;
const wrapperHeight = buttonHeight + wrapperPadding * 2;

export const ThumbnailReorderWrapper = styled.div`
  padding: ${rem(wrapperPadding)};
  height: ${rem(wrapperHeight)};
  border-radius: ${rem(wrapperHeight / 2)};
  background: white;
  box-shadow: 0 7px 14px 0 rgba(0, 0, 0, 0.1);
  top: ${rem(98)}; /* Leave room for pill to wrap if needed */
  left: ${rem(spacing20)};
  right: ${rem(spacing20)};
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${grey7};
`;

export const MoveLabelStyled = styled.div`
  font-size: ${rem(fontSize14)};
  text-align: center;
  padding: 0 ${rem(10)};
`;

export const EditMask = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.5);
`;

export const THUMBNAIL_HOVER_DURATION = 200;
